import { backend } from "../config/backend";

export const SocketsUrls = Object.freeze({
	DEPOSITS: `${backend.urlEndPoint}/deposits`,
	WITHDRAWALS: `${backend.urlEndPoint}/withdrawals`,
	TRANSFER: `${backend.urlEndPoint}/transfer`,
});
